module.exports = __webpack_public_path__ + "img/ico_lianmengliwu.0b72a174.png";